import React, { useMemo, useRef } from 'react';
import {
  Route,
  RouteProps,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { getUser, setUser } from '../../../utilities/storage';
import { getRedirectUrl, useRedirect } from '../../../hooks/useRedirect';
import useQueryParam from '../../hooks/useQueryParam';
import { useDispatch } from 'react-redux';
import { useAsyncFn, useMount } from 'react-use';
import { larkiApiNoAuthentication } from '../../../utilities/api';
import { PulseLoader } from 'react-spinners';
import Page from '../../../components/page/Page';
import { rtkApi } from '../../../redux/rtk';
import { getUserProfile } from '../../../redux/actions';

const PrivateRoute = ({ component, ...rest }: RouteProps) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const token = useQueryParam('token');
  const searchParams = new URLSearchParams(window.location.search);
  const userRef = useRef(getUser());
  const redirect = useRedirect();

  const [{ loading }, autoLogin] = useAsyncFn(
    async () => {
      const { data } = await larkiApiNoAuthentication.post(
        '/user/verify-token',
        {
          token,
        }
      );
      userRef.current = data;
      // store user cookie
      setUser(data, data.is_anonymous);
      dispatch(getUserProfile()); // legacy
      dispatch(rtkApi.util.invalidateTags(['User']));
      if (token) {
        searchParams.delete('token');
      }
      history.replace({
        search: searchParams.toString(),
      });
    },
    [token],
    {
      loading: token !== null && !userRef.current,
    }
  );

  useMount(() => {
    if (token && !userRef.current) {
      autoLogin();
    }
  });

  const to = useMemo(
    () =>
      getRedirectUrl('/login', true, {
        redirectUrl: location.pathname,
      }),
    [location.pathname]
  );

  if (loading) {
    return (
      /* @ts-expect-error Page */
      <Page className='PageCenter'>
        <PulseLoader size={16} color='#31a283' />
      </Page>
    );
  }

  if (!userRef.current) {
    redirect.push(to.toString());
    return null;
  }
  return <Route {...rest} component={component} />;
};

export default PrivateRoute;
